<script setup lang="ts">
interface Props {
  icon: `i-${string}:${string}`
}

defineProps<Props>()
</script>

<template>
  <div
    class="border-2 border-brand-primary/10 rounded-8 inline-flex text-brand-gradient items-center gap-2.5 py-2 px-4.5"
  >
    <span :class="[icon, 'bg-brand-gradient']" />
    <span class="font-semibold text-xs">
      <slot />
    </span>
  </div>
</template>
